import React, { Component } from "react";
import PageTitle from "../../components/shared/PageTitle";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import AccountWidget from "../../components/shared/AccountWidget";
import styles from "../../thema/style";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import classes from "../../thema/style";

class CheckoutSuccess extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  static getDerivedStateFromProps(props, state) {
    if (!(props.location.state && props.location.state.order))
      props.history.push({ pathname: "/" });
  }

  paymentMethodValueToKey(method) {
    switch (method) {
      case "Kapıda Ödeme":
        return "payAtDoor";
      case "Havale / EFT":
        return "transfer";
      case "Online Ödeme":
        return "online";
      default:
        return null;
    }
  }

  render() {
    return (
      <React.Fragment>
        <PageTitle title={"Sipariş Başarılı"} />
        <div className="row">
          <div className={"container"}>
            <div className="row">
              <div className={"col-md-9 mb-5"}>
                <h3 style={{ marginTop: 20 }}>Siparişiniz Tamamlandı!</h3>
                <p style={{ marginTop: 5 }}>
                  Siparişiniz başarıyla tarafımıza ulaşmıştır!
                </p>
                {this.props.location.state &&
                this.props.location.state.is_guest ? (
                  <p>
                    Sipariş detayları ve siparişinizi takip edebilmek için
                    E-Mail adresinizi Gelen kutusu (yada Diğer/Spam kutusu)
                    maillerinizi kontrol edebilirsiniz.
                  </p>
                ) : (
                  <p>
                    Sipariş detayları ve siparişiniz takip edebilmek için{" "}
                    <a className="text-success" href="#">
                      Hesabım
                    </a>{" "}
                    sayfasından siparişlerinizi takip edebilirsiniz.{" "}
                  </p>
                )}
                <br />

                <div
                  dangerouslySetInnerHTML={{
                    __html: this.props.setting.setting.payments
                      .find((item) => {
                        if (
                          item.method ===
                          this.paymentMethodValueToKey(
                            this.props.location.state.order.payment
                          )
                        ) {
                          return true;
                        }
                        return false;
                      })
                      .successMessage.replace(
                        /{{orderid}}/g,
                        this.props.location.state.order.c_number
                      )
                      .replace(
                        /{{total_price}}/g,
                        parseFloat(
                          this.props.location.state.order.total_price
                        ).toFixed(2)
                      ),
                  }}
                />
                <Link
                  to="/"
                  className={`btn ${styles.buttonDefaultSM} `}
                  style={{ marginTop: 10 }}
                >
                  Anasayfaya Dön
                </Link>
              </div>
              <div className={"col-md-3"}>
                <AccountWidget />
                <CategoriesWidget />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ setting }) => {
  return { setting };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutSuccess);



// WEBPACK FOOTER //
// ./src/routers/Checkout/success.js